import React, { ReactNode } from 'react';
import { Box, DialogContent, DialogContentText } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';


type NotifyDialogProps = {
    text1?: ReactNode,
    text2?: ReactNode,
} & ModalActionProps;

const NotifyDialog = ({ text1, text2 }: NotifyDialogProps) => {
    return (
        <Box>
            {text1 && (
                <DialogContent>
                    {typeof text1 === 'string' ?
                        <DialogContentText>{text1}</DialogContentText> :
                        text1
                    }
                </DialogContent>
            )}
            {text2 && (
                <DialogContent>
                    <DialogContentText>{text2}</DialogContentText>
                </DialogContent>
            )}
        </Box>
    );
};

export default NotifyDialog;
